exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-item{height:150px}.activeItem{background:#009688;color:#fff}.typelist{padding:5px 0}.typelist span{margin-right:15px;font-weight:700}.type-active{color:#009688}.typelist_line{height:8px;width:100%;opacity:.5;background:#d9e0e6;margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/queuingUp/queueNumber/index.vue
// module id = 0NU5
// module chunks = 37 239